import { Component, computed, input, output } from '@angular/core';

export type GameResultVariant = 'vitoria' | 'derrota';

@Component({
  selector: 'app-game-result-modal',
  imports: [],
  templateUrl: './game-result-modal.html',
  styleUrl: './game-result-modal.scss',
})
export class GameResultModal {
  readonly variant = input.required<GameResultVariant>();
  readonly characterName = input<string | null>(null);

  readonly playAgain = output<void>();
  readonly backToHome = output<void>();

  protected readonly icon = computed(() =>
    this.variant() === 'vitoria' ? 'emoji_events' : 'sentiment_dissatisfied',
  );
  protected readonly title = computed(() =>
    this.variant() === 'vitoria' ? 'Você Venceu!' : 'Você Perdeu!',
  );
  protected readonly chipLabel = 'Partida Concluída';
}
